import fetch from 'services/request';
import {
  CreateProductBody,
  GetProductListAction,
  ICreateOrUpdateSupplierBody,
  UpdateProductTaxBody,
} from './constants';

const API_V1 = '/api/v1';
const CATEGORY_BASE_URL = API_V1 + '/category';
const PRODUCT_BASE_URL = API_V1 + '/product';
const SUPPLIER_BASE_URL = API_V1 + '/supplier';
const api = {
  category: {
    getAll: () =>
      fetch({
        method: 'get',
        url: `${CATEGORY_BASE_URL}/all-category`,
      }),

    create: (data: { categoryName: string }) =>
      fetch({
        method: 'post',
        url: `${CATEGORY_BASE_URL}/add-category`,
        body: data,
      }),

    update: (data: { categoryId: string; categoryName: string }) =>
      fetch({
        method: 'put',
        url: `${CATEGORY_BASE_URL}/update-category`,
        body: data,
      }),

    updateOrder: (data: { categories: Array<{ id: string; order: number }> }) =>
      fetch({
        method: 'put',
        url: `${CATEGORY_BASE_URL}/update-order`,
        body: data,
      }),

    sort: (data: { categoryIds: string[] }) =>
      fetch({
        method: 'post',
        url: `${CATEGORY_BASE_URL}/sorts`,
        body: data.categoryIds,
      }),

    delete: (categoryId: string) =>
      fetch({
        method: 'delete',
        url: `${CATEGORY_BASE_URL}/delete-category/${categoryId}`,
      }),
  },
  product: {
    getList: (body: GetProductListAction) =>
      fetch({
        method: 'get',
        url: `${PRODUCT_BASE_URL}/list-paging-by-category/${body.categoryId}`,
        params: {
          page: body.page,
          size: body.size,
          keySearch: body.search,
        },
      }),
    getDetail: (productId: string) =>
      fetch({
        method: 'get',
        url: `${PRODUCT_BASE_URL}/detail/${productId}`,
      }),
    create: (data: CreateProductBody) =>
      fetch({
        method: 'post',
        url: PRODUCT_BASE_URL,
        body: data,
      }),

    update: (data: CreateProductBody) =>
      fetch({
        method: 'put',
        url: `${PRODUCT_BASE_URL}/update`,
        body: data,
      }),

    updateTax: (data: UpdateProductTaxBody) =>
      fetch({
        method: 'post',
        url: `${PRODUCT_BASE_URL}/update-tax`,
        body: data,
      }),

    updateQuantity: (data: { productId: string; quantity: number }) =>
      fetch({
        method: 'post',
        url: `${PRODUCT_BASE_URL}/update-quantity`,
        body: data,
      }),
    updateQuantitys: (data: { productId: string; quantity: number }[]) =>
      fetch({
        method: 'post',
        url: `${PRODUCT_BASE_URL}/update-multiple-quantity`,
        body: data,
      }),

    delete: (data: { productId: string; categoryId: string }) =>
      fetch({
        method: 'delete',
        url: `${PRODUCT_BASE_URL}/delete/${data.productId}`,
        params: {
          categoryId: data.categoryId,
        },
      }),
    sort: (products: string[]) =>
      fetch({
        method: 'post',
        url: `${PRODUCT_BASE_URL}/sorts`,
        body: products,
      }),
  },
  supplier: {
    getList: (keySearch: string) =>
      fetch({
        method: 'get',
        url: `${SUPPLIER_BASE_URL}/list`,
        params: {
          keySearch,
        },
      }),
    createOrUpdate: (data: ICreateOrUpdateSupplierBody) =>
      fetch({
        method: 'post',
        url: `${SUPPLIER_BASE_URL}/add-or-update`,
        body: data,
      }),
    getDetail: (supplierId: string) =>
      fetch({
        method: 'get',
        url: `${SUPPLIER_BASE_URL}/detail/${supplierId}`,
      }),
    delete: (supplierId: string) =>
      fetch({
        method: 'post',
        url: `${SUPPLIER_BASE_URL}/delete/${supplierId}`,
      }),
  },
};

export default api;
